import { FETCH_SECRETS } from './types';
import api from '../apis/api';
import getMessageFromApiError from '../util/getMessageFromApiError';
import { setErrorMessage } from './errorMessage';

export const fetchSecrets = (project_uuid, id) => async (dispatch) => {
  try {
    if (!id) {
      if (!project_uuid) {
        throw new Error('project_uuid is required when id is not provided');
      }
      id = project_uuid;
    }
    const res = await api.get(`/project/${id}/secrets/`);
    dispatch({
      type: FETCH_SECRETS,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const getProjectSecrets = async (project_uuid) => {
  try {
    const res = await api.get(`/project/${project_uuid}/secrets`);
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};

export const removeSecret = (project_uuid, id, name) => async (dispatch) => {
  try {
    await api.delete(`/project/${id}/secrets/${name}`);
    dispatch(fetchSecrets(project_uuid, id));
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};
export const putSecret =
  (project_uuid, id, name, value) => async (dispatch) => {
    try {
      await api.put(`/project/${id}/secrets/${name}`, { value });
      dispatch(fetchSecrets(project_uuid, id));
    } catch (error) {
      const message = getMessageFromApiError(error);
      dispatch(setErrorMessage(message));
      throw new Error(`API Error - ${message}`);
    }
  };

export const removeProjectSecret = async (project_uuid, name) => {
  try {
    await api.delete(`/project/${project_uuid}/secrets/${name}`);
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};
